import { render, staticRenderFns } from "./standard_print_label.vue?vue&type=template&id=ab342994&scoped=true&"
import script from "./standard_print_label.vue?vue&type=script&lang=js&"
export * from "./standard_print_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab342994",
  null
  
)

export default component.exports